import { libraryName } from '../constants.js';
import consoleLogHandler from './logHandlers/consoleLogHandler.js';
import serverLogHandler from './logHandlers/serverLogHandler.js';

var getLogHandler = function getLogHandler() {
  consoleLogHandler.setNext(serverLogHandler);
  return consoleLogHandler;
};
var customLogger = function customLogger(level, message) {
  var logMessage = "".concat(libraryName, " : ").concat(message);
  getLogHandler().handle(level, logMessage);
};

export { customLogger };
